import React from 'react';
import { Header } from 'semantic-ui-react';
import {
    buildRiderDescriptionArray,
    getChronicRiderLabel,
    getChronicRiderLabelDescription, getMaternityRiderLabel,
    getMentalRiderLabel
} from "../utils/riders";
import {CustomDivider, CustomGrid} from "./custom-common";
import {withRouter} from "react-router-dom";
import {connect} from "react-redux";
import {getLocalization} from "../utils/localization";

const mapStateToProps = (state, ownProps) => {
    const { user, initialData } = state;
    const { lang } = user;
    const { riderLabels, ratedClass } = initialData;
    const contractTerms = ratedClass?.contractTerms || {};

    const { chronicCoverageLimit, mentalCoverageLimit, maternityCoverageLimit } = contractTerms;

    return {
        lang,
        riderLabels,
        chronicCoverageLimit,
        mentalCoverageLimit,
        maternityCoverageLimit,
        ...ownProps,
    };
};


const AdditionalRidersRows = ({ lang, riderLabels, chronicCoverageLimit, mentalCoverageLimit, maternityCoverageLimit}) => {
    const localization = getLocalization(lang);
    const strings = localization.yourBrellaPlanAlsoIncludes;

    const chronicLabel = getChronicRiderLabel(strings, riderLabels);
    const chronicRiderLabelDescription = getChronicRiderLabelDescription(strings, riderLabels);
    const mentalLabel = getMentalRiderLabel(strings, riderLabels);
    const maternityLabel = getMaternityRiderLabel(strings, riderLabels);

    const riders = [
        {
            limit: chronicCoverageLimit,
            label: chronicLabel,
            riderLabel: chronicRiderLabelDescription,
            details1: strings.chronicDetails1,
            amount: strings.chronicDetailsAmount,
            details2: strings.chronicDetails2,
        },
        {
            limit: mentalCoverageLimit,
            label: mentalLabel,
            riderLabel: mentalLabel,
            details1: strings.mentalDetails1,
            amount: strings.mentalDetailsAmount,
            details2: strings.mentalDetails2,
        },
        {
            limit: maternityCoverageLimit,
            label: maternityLabel,
            riderLabel: maternityLabel,
            details1: strings.maternityDetails1,
            amount: strings.maternityDetailsAmount,
            details2: strings.maternityDetails2 + strings.maternityDetails3 + strings.maternityDetails4,
        },
    ].filter(({limit}) => limit);

    return (<>
        {riders.length !== 0 && riders.map((rider, index) => (
            <React.Fragment key={index}>
                <CustomGrid.Row className="additionalRiderBox small">
                    <div>
                        <Header as="h4">{rider.label}{' '}</Header>
                        <span>${rider.limit}</span>
                    </div>
                    <p>
                        {buildRiderDescriptionArray(rider.details1, rider.amount, rider.details2, rider.riderLabel, true)
                            .map((s, index) => <React.Fragment key={index}>{s}</React.Fragment>)
                        }
                    </p>
                </CustomGrid.Row>
                <CustomDivider hidden small/>
            </React.Fragment>
        ))}
    </>);
};

export default withRouter(connect(mapStateToProps)(AdditionalRidersRows));
